import { render, staticRenderFns } from "./DetailSaldo.vue?vue&type=template&id=e6e42dc0&scoped=true&"
import script from "./DetailSaldo.vue?vue&type=script&lang=js&"
export * from "./DetailSaldo.vue?vue&type=script&lang=js&"
import style0 from "./DetailSaldo.vue?vue&type=style&index=0&id=e6e42dc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e42dc0",
  null
  
)

export default component.exports